import React from "react";

import NewConversationButton from "../LandingPage/NewConversationButton";
import { s360ConfigService } from "../Services/S360Config";

import "../InitialForm/InitialFormStyleSheet.css";

function ChannelBox(props) {
  return (
    <div style={{ minHeighteight: "6rem", width: "100%" }}>
      {props?.item?.chatButton ? (
        <NewConversationButton
          page="channels"
          onStartChanelClick={() => {
            if (!s360ConfigService?.config?.sandBox) {
              props?.moveToNextScreen();
            }
          }}
          buttonText={props?.item?.label}
        />
      ) : (
        <a
          href={s360ConfigService?.config?.sandBox ? "" : props.item.link}
          target="_blank"
          rel="noreferrer"
          className="styles_channel__396ZG styles_whatsapp__80fGh"
          style={{
            width: "100%",
            border: "1px solid #d4cdcd",
            marginBottom: "1rem",
            marginTop: "1rem",
            borderRadius: "0.8rem",
            justifyContent: props?.item?.chatButton
              ? "space-between"
              : "flex-start",
            textDecoration: "none",
          }}
        >
          {props.item.icon.includes("http") && (
            <div className="styles_channelIcon__1i0qs styles_whatsapp__80fGh">
              <img
                className="channelBoxBgColor"
                src={props.item?.icon}
                width="20"
                height="20"
                alt=""
              />
            </div>
          )}
          <p className="styles_channelName__Q8vJ4">{props.item.label}</p>
        </a>
      )}
    </div>
  );
}

export default ChannelBox;
//refactor this code
